import get from 'lodash/get';

import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../utils/redux';
import chatConsts from '../chatConnection/constants';

const requestOptions = {
  endpoint: 'complaint_notifications',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'status',
      selector: 'status',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

export const consts = createReqConsts('complaints', 'unresolved-list', [
  'LOAD_MORE',
  'TOGGLE_MENU_VISIBILITY',
  'REMOVE_COMPLAINT',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions);

export const paginationConsts = createReqConsts(
  'complaints',
  'unresolved-list-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
);

const initialState = {
  ...rootState,
  reportsVisible: false,
  pagination: { offset: 0, limit: 10 },
};

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.SUCCEED: {
      return {
        ...state,
        ...rootState,
        succeed: true,
        list: action.payload,
      };
    }

    case consts.REJECTED: {
      return {
        ...state,
        ...rootState,
        rejected: true,
        ...action.payload,
      };
    }

    case consts.TOGGLE_MENU_VISIBILITY: {
      return {
        ...state,
        reportsVisible: action.payload,
      };
    }

    case paginationConsts.SUCCEED: {
      return {
        ...state,
        list: [...state.list, ...action.payload],
      };
    }

    case chatConsts.NEW_COMPLAINT: {
      return {
        ...state,
        list: [action.payload, ...state.list],
      };
    }

    case consts.REMOVE_COMPLAINT: {
      return {
        ...state,
        list: state.list.filter(({ id }) => id !== get(action, 'payload.id')),
      };
    }

    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/complaints/complaintUnResolvedList.js